const apiUrl = process.env.REACT_APP_API_URL;
export const GetComandesGeneradesIdPdf = async ( page : string, id : string) => {
    try {
        const response = await fetch(`${apiUrl}:8072/comandesgenerades/${id}/pdf`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        if (response.ok) {
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        } else {
            alert(await response.text());
        }
        return "";
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
